import { render, staticRenderFns } from "./SiportLine.vue?vue&type=template&id=64fef210&scoped=true&"
import script from "./SiportLine.vue?vue&type=script&lang=js&"
export * from "./SiportLine.vue?vue&type=script&lang=js&"
import style0 from "./SiportLine.vue?vue&type=style&index=0&id=64fef210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fef210",
  null
  
)

export default component.exports